const PREFIX = 'PARTNER_MANAGER_AREA_';
const GROUP_MEMBERSHIP = 'GROUP_MEMBERSHIP';

export const GET_IS_GROUP_MEMBERSHIP_ADDED_TO_PARTNER = `${PREFIX}GET_IS_${GROUP_MEMBERSHIP}_ADDED_TO_PARTNER`;
export const SET_IS_GROUP_MEMBERSHIP_ADDED_TO_PARTNER = `${PREFIX}SET_IS_${GROUP_MEMBERSHIP}_ADDED_TO_PARTNER`;
export const GET_GROUP_MEMBERSHIP = `GET_${GROUP_MEMBERSHIP}`;
export const SET_GROUP_MEMBERSHIP = `SET_${GROUP_MEMBERSHIP}`;

